// icons.ts
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faPen,
    faTrash,
    faClockRotateLeft,
    faCalendarCheck,
    faCopy,
    faArchive,
    faImage,
    faEye,
    faCircleXmark,
    faAngleDown,
    faAngleLeft,
    faGear,
    faFloppyDisk,
    faEnvelope,
    faLocationDot,
    faUser,
    faPhone,
    faUsers,
    faDownload,
    faMobileScreen,
    faRightFromBracket,
    faBell,
    faCircleInfo,
    faAdd,
    faCircleCheck,
} from '@fortawesome/free-solid-svg-icons'
// import { faArchive as faArchiveDuoTone } from '@fortawesome/pro-duotone-svg-icons';
import { faCircleQuestion  } from '@fortawesome/free-regular-svg-icons';

// Define the types for the props
interface IconProps {
    color?: string
    style?: React.CSSProperties
}

// Create reusable icon components with preset styles
export const EditIcon = ({
    color = '#173878',
    style = {},
}: IconProps) => {
    const defaultStyle = { width: '16px', height: '16px', cursor: 'pointer' };
    return (
    <FontAwesomeIcon
        icon={faPen}
        color={color}
        style={{ ...defaultStyle, ...style }}
    />
);
};

export const ArchiveIcon = ({
    color = '#F03D3E',
    style = {},
}: IconProps) => {
    const defaultStyle = { width: '16px', height: '16px', cursor: 'pointer' };
    return (
    <FontAwesomeIcon
        icon={faArchive}
        color={color}
        style={{ ...defaultStyle, ...style }}
    />
);
};

export const DeleteIcon = ({
   
}: IconProps) => {
    const defaultStyle = { width: '16px', height: '16px', cursor: 'pointer' };
    return (
        <i className="feather-trash  font-s-16 icon-delete"></i>
);
};

export const RestoreIcon = ({
    color = '#4B95B7',
    style = {},
}: IconProps) => {
    const defaultStyle = { width: '16px', height: '16px', cursor: 'pointer' };
    return (
    <FontAwesomeIcon
        icon={faClockRotateLeft}
        color={color}
        style={{ ...defaultStyle, ...style }} className='mr-1'
    />
);
};

export const CalenderIcon = ({
    color = '#173878',
    style = {},
}: IconProps) => {
    const defaultStyle = { width: '16px', height: '16px', cursor: 'pointer' };
    return (
    <FontAwesomeIcon
        icon={faCalendarCheck}
        color={color}
        style={{ ...defaultStyle, ...style }}
    />
);
};

export const CopyIcon = ({
    color = '#173878',
    style = {},
}: IconProps) => {
    const defaultStyle = { width: '16px', height: '16px', cursor: 'pointer' };
    return (
    <FontAwesomeIcon
        icon={faCopy}
        color={color}
        style={{ ...defaultStyle, ...style }}
    />
);
};

export const ImageIcon = ({
    color = '#173878',
    style = {},
}: IconProps) => {
    const defaultStyle = { width: '16px', height: '16px', cursor: 'pointer' };
    return (
    <FontAwesomeIcon
        icon={faImage}
        color={color}
        style={{ ...defaultStyle, ...style }}
    />
);
};

export const ViewIcon = ({
    color = '#5E9FBD',
    style = {},
}: IconProps) => {
    const defaultStyle = { width: '16px', height: '16px', cursor: 'pointer' };
    return (
    <FontAwesomeIcon
        icon={faEye}
        color={color}
        style={{ ...defaultStyle, ...style }}
    />
);
};

export const CloseIcon = ({
    color = '#5E9FBD',
    style = {},
}: IconProps) => {
    const defaultStyle = { width: '16px', height: '16px', cursor: 'pointer' };
    return (
    <FontAwesomeIcon
        icon={faCircleXmark}
        color={color}
        style={{ ...defaultStyle, ...style }}
    />
);
};

export const DownArrowIcon = ({
    color = 'black',
    style = {},
}: IconProps) => {
    const defaultStyle = { width: '16px', height: '16px', cursor: 'pointer' };
    return (
    <FontAwesomeIcon
        icon={faAngleDown}
        color={color}
        style={{ ...defaultStyle, ...style }}
    />
);
};

export const LeftArrowIcon = ({
    color = 'black',
    style = {},
}: IconProps) => {
    const defaultStyle = { width: '16px', height: '16px', cursor: 'pointer' };
    return (
    <FontAwesomeIcon
        icon={faAngleLeft}
        color={color}
        style={{ ...defaultStyle, ...style }}
    />
);
};

export const SettingsIcon = ({
    color = 'black',
    style = {},
}: IconProps) => {
    const defaultStyle = { width: '16px', height: '16px', cursor: 'pointer' };
    return (
    <FontAwesomeIcon
        icon={faGear}
        color={color}
        style={{ ...defaultStyle, ...style }}
    />
    );
};

// SaveIcon component
export const SaveIcon = ({
    color = '#173878',
    style = {},
  }: IconProps) => {
    const defaultStyle = { width: '16px', height: '16px', cursor: 'pointer' };
    return (
      <FontAwesomeIcon
        icon={faFloppyDisk}
        color={color}
        style={{ ...defaultStyle, ...style }}
      />
    );
  };

export const EmailIcon = ({
    color = '#5E9FBD',
    style = {},
}: IconProps) => {
    const defaultStyle = { width: '16px', height: '16px', cursor: 'pointer' };
    return (
    <FontAwesomeIcon
        icon={faEnvelope}
        color={color}
        style={{ ...defaultStyle, ...style }}
    />
);
};

export const LocationIcon = ({
    color = '#5E9FBD',
    style = {},
}: IconProps) => {
    const defaultStyle = { width: '16px', height: '16px', cursor: 'pointer' };
    return (
    <FontAwesomeIcon
        icon={faLocationDot}
        color={color}
        style={{ ...defaultStyle, ...style }}
    />
);
};

export const UserIcon = ({
    color = '#5E9FBD',
    style = {},
}: IconProps) => {
    const defaultStyle = { width: '16px', height: '16px', cursor: 'pointer' };
    return (
    <FontAwesomeIcon
        icon={faUser}
        color={color}
        style={{ ...defaultStyle, ...style }}
    />
);
};

export const PhoneIcon = ({
    color = '#5E9FBD',
    style = {},
}: IconProps) => {
    const defaultStyle = { width: '16px', height: '16px', cursor: 'pointer' };
    return (
    <FontAwesomeIcon
        icon={faPhone}
        color={color}
        style={{ ...defaultStyle, ...style }}
    />
);
};

export const UsersIcon = ({
    color = '#5E9FBD',
    style = {},
}: IconProps) => {
    const defaultStyle = { width: '16px', height: '16px', cursor: 'pointer' };
    return (
    <FontAwesomeIcon
        icon={faUsers}
        color={color}
        style={{ ...defaultStyle, ...style }}
    />
);
};

export const DownloadIcon = ({
    color = '#5E9FBD',
    style = {},
}: IconProps) => {
    const defaultStyle = { width: '16px', height: '16px', cursor: 'pointer' };
    return (
    <FontAwesomeIcon
        icon={faDownload}
        color={color}
        style={{ ...defaultStyle, ...style }}
    />
);
};

export const MobileScreenIcon = ({
    color = '#5E9FBD',
    style = {},
}: IconProps) => {
    const defaultStyle = { width: '16px', height: '16px', cursor: 'pointer' };
    return (
    <FontAwesomeIcon
        icon={faMobileScreen}
        color={color}
        style={{ ...defaultStyle, ...style }}
    />
);
};

export const HelpIcon = ({
    color = '#5E9FBD',
    style = {},
}: IconProps) => {
    const defaultStyle = { width: '16px', height: '16px', cursor: 'pointer' };
    return (
    <FontAwesomeIcon
        icon={faCircleQuestion}
        color={color}
        style={{ ...defaultStyle, ...style }}
    />
);
};

export const SignoutIcon = ({
    color = '#5E9FBD',
    style = {},
}: IconProps) => {
    const defaultStyle = { width: '16px', height: '16px', cursor: 'pointer' };
    return (
    <FontAwesomeIcon
        icon={faRightFromBracket}
        color={color}
        style={{ ...defaultStyle, ...style }}
    />
);
};

export const NotificationIcon = ({
    color = '#5E9FBD',
    style = {},
}: IconProps) => {
    const defaultStyle = { width: '16px', height: '16px', cursor: 'pointer' };
    return (
    <FontAwesomeIcon
        icon={faBell}
        color={color}
        style={{ ...defaultStyle, ...style }}
    />
);
};

export const InfoIcon = ({
    color = '#5E9FBD',
    style = {},
}: IconProps) => {
    const defaultStyle = { width: '16px', height: '16px', cursor: 'pointer' };
    return (
    <FontAwesomeIcon
        icon={faCircleInfo}
        color={color}
        style={{ ...defaultStyle, ...style }}
    />
);
};

export const AddIcon = ({
    color = '#5E9FBD',
    style = {},
}: IconProps) => {
    const defaultStyle = { width: '16px', height: '16px', cursor: 'pointer' };
    return (
    <FontAwesomeIcon
        icon={faAdd}
        color={color}
        style={{ ...defaultStyle, ...style }}
    />
);
};

export const TickIcon = ({
    color = '#4CBB17',
    style = {},
}: IconProps) => {
    const defaultStyle = { width: '16px', height: '16px', cursor: 'pointer' };
    return (
    <FontAwesomeIcon
        icon={faCircleCheck}
        color={color}
        style={{ ...defaultStyle, ...style }}
    />
);
};
